<!-- Item Start Outlet -->
<ng-template [cxOutlet]="'cx-cart-item-list-row'">
  <!-- Item Details -->
  <td role="cell" class="cx-table-item-container">
    <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl">

      <img class="imageAvailable"
        *ngIf="item.product && item.product.images && item.product.images.PRIMARY && item.product.images.PRIMARY.thumbnail"
        src="{{item.product.images.PRIMARY.thumbnail.url}}" alt="image" />
      <img class="imageAvailable"
        *ngIf="item.product && item.product.images && item.product.images && item.product.images.length"
        src="{{item.product.images[2].url}}" alt="image" />
      <img class="imageNotAvailable" *ngIf="item.product && !item.product.images"
        src="{{ '../../../../../../../assets/images/tea-hot-icon.svg'}}" alt="image">
    </a>
    <div class="cx-info">
      <div *ngIf="item.product?.name" class="cx-name">
        <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl">{{ item.product?.name
          }}</a>
      </div>
      <div *ngIf="item.product?.code" class="cx-code">
        {{ "cartitemlistrow.sku" | cxTranslate }}{{ item.product?.code }}
      </div>




      <!-- Error  -->
      <div *ngIf="!item.isQuantityUpdated && afterSimulateAction">
        <div class="error" *ngIf="item.isOOS">
          <ng-container *ngIf="item.nextStockAvailableDate !== undefined; else OOSWIthoutDate">
            <span>{{ "cartitemlistrow.errors.tempOutOfStockWithDate" | cxTranslate : { date: item.nextStockAvailableDate
              } }}</span>
          </ng-container>
        </div>
        <div class="error" *ngIf="item.isPartiallyOOS">
          <ng-container *ngIf="item.partiallyConfirmedQty !== undefined; else partialOOSWIthoutDate">
            <span>{{ "cartitemlistrow.errors.partialOutOfStockWithQuantity" | cxTranslate : { quantity:
              item.partiallyConfirmedQty } }}</span>
          </ng-container>
        </div>
      </div>




    </div>
  </td>

  <!-- Quantity -->
  <td role="cell" class="cx-table-quantity-container">
    <div *ngIf="!isCheckoutPage" class="item-counter">
      <button type="button" (click)="decrement(item)"
        [disabled]="quantityControl.disabled || quantityControl.value <= min" [tabindex]="
          quantityControl.disabled || quantityControl.value <= min ? -1 : 0
        " attr.aria-label="{{ 'itemCounter.removeOne' | cxTranslate }}">
        -
      </button>
      <input #qty type="number" [min]="min" [max]="999" [maxlength]="3" [step]="step" [ngClass]="{
          'warning-input':
            !item.isQuantityUpdated &&
            afterSimulateAction &&
             (!item.isOOS || !item.isPartiallyOOS) 
            
        }" [readonly]="readonly" [tabindex]="readonly ? -1 : 0" [formControl]="quantityControl"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        attr.aria-label="{{ 'itemCounter.quantity' | cxTranslate }}" (change)="quantitySelect($event, item)" />
      <button type="button" (click)="increment(item)"
        [disabled]="quantityControl.disabled || quantityControl.value >= max" tabindex="0"
        attr.aria-label="{{ 'itemCounter.addOneMore' | cxTranslate }}">
        +
      </button>
    </div>
    <div *ngIf="isCheckoutPage" class="p-3">
      {{ item.quantity }}
    </div>
  </td>

  <!-- Remove -->
  <td *ngIf="!isCheckoutPage" role="cell" class="cx-table-remove-container">
    <button (click)="removeItem()" [disabled]="isRemovingItem" [cxAtMessage]="'cartItems.itemRemoved' | cxTranslate"
      [disabled]="quantityControl.disabled" attr.aria-label="{{ 'addToCart.removeFromCart' | cxTranslate }}"
      class="link cx-action-link cx-remove-btn"></button>

  </td>

  <!-- Unit Price -->
  <td role="cell" class="cx-table-unit-container">
    <div *ngIf="item?.basePrice" class="cx-value">
      {{ item.basePrice?.formattedValue }}
    </div>
  </td>

  <!-- Discount -->
  <td role="cell" class="cx-table-unit-container"
    *ngIf="isCheckoutPage && item?.orderEntryDiscountAmount?.formattedValue">
    <div class="cx-value">
      {{ item?.orderEntryDiscountAmount.formattedValue }}
    </div>
  </td>
  <!-- Total Price -->

  <td role="cell" class="cx-table-total-container">
    <div *ngIf="item?.totalPrice" class="cx-value">
      {{ item?.totalPrice.formattedValue }}
    </div>
  </td>
</ng-template>


<ng-template #partialOOSWIthoutDate>
  <span>{{
    "cartitemlistrow.errors.partialOutOfStockWithOutQuantity" | cxTranslate
    }}</span>
</ng-template>

<ng-template #OOSWIthoutDate>
  <span>{{
    "cartitemlistrow.errors.tempOutOfStockWithOutDate" | cxTranslate
    }}</span>
</ng-template>